import { useTranslation } from 'react-i18next'
import { BookOpen } from 'lucide-react'
import { EntityPageHeader } from '@/shared/components'
import { ProgrammeList } from '../components'

export function ProgrammesListPage() {
  const { t } = useTranslation()

  return (
    <div>
      <EntityPageHeader
        icon={BookOpen}
        title={t('programmes.pageTitle', 'Programmes')}
        subtitle={t('programmes.subtitle', 'Configurez les programmes de suivi')}
        createTo="/programmes/create"
        createLabel={t('programmes.createButton', 'Créer un programme')}
      />
      <ProgrammeList />
    </div>
  )
}
